import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { queryOptions, useQuery } from '@tanstack/react-query';

import SettingsService from '@/services/settings.service';

export const getSettingsOptions = queryOptions({
  queryKey: ['settings'],
  queryFn: SettingsService.getEnv,
  staleTime: Infinity,
});

export const useSubscriptionStatus = () => {
  return useQuery({
    queryKey: ['subscription-status'],
    queryFn: SettingsService.getSubscriptionStatus,
  });
};

export const useGetSettings = () => {
  const query = useQuery(getSettingsOptions);
  const { data, isSuccess, isError } = query;

  useEffect(() => {
    if (isSuccess && data) {
      const { tenant, tenantId, modules, features } = data;

      Sentry.setTag('tenant', tenant);
      Sentry.setTag('tenant_id', tenantId?.toString());
      Sentry.setContext('tenant_settings', {
        modules,
        features,
      });
    }

    if (isError) {
      Sentry.setTag('tenant', null);
      Sentry.setTag('tenant_id', null);
      Sentry.setContext('tenant_settings', null);
    }
  }, [isSuccess, isError, data]);

  return query;
};
